/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { InventoriesVariablesValuesResponse as ApiInventoriesVariablesValuesResponse } from '../models/api/inventories-variables-values-response';
import { InventoryResponse as ApiInventoryResponse } from '../models/api/inventory-response';
import { ListCommentsResponse as ApiListCommentsResponse } from '../models/api/list-comments-response';
import { ListInventoriesResponse as ApiListInventoriesResponse } from '../models/api/list-inventories-response';
import { ListMonetaryValuesResponse as ApiListMonetaryValuesResponse } from '../models/api/list-monetary-values-response';
import { ListValuesResponse as ApiListValuesResponse } from '../models/api/list-values-response';
import { MonetaryValueResponse as ApiMonetaryValueResponse } from '../models/api/monetary-value-response';
import { ValueResponse as ApiValueResponse } from '../models/api/value-response';
import { createInventoryMonetaryValue } from '../fn/inventory/create-inventory-monetary-value';
import { CreateInventoryMonetaryValue$Params } from '../fn/inventory/create-inventory-monetary-value';
import { createInventoryMonetaryValueComment } from '../fn/inventory/create-inventory-monetary-value-comment';
import { CreateInventoryMonetaryValueComment$Params } from '../fn/inventory/create-inventory-monetary-value-comment';
import { createInventoryValue } from '../fn/inventory/create-inventory-value';
import { CreateInventoryValue$Params } from '../fn/inventory/create-inventory-value';
import { createInventoryValueComment } from '../fn/inventory/create-inventory-value-comment';
import { CreateInventoryValueComment$Params } from '../fn/inventory/create-inventory-value-comment';
import { getInventory } from '../fn/inventory/get-inventory';
import { GetInventory$Params } from '../fn/inventory/get-inventory';
import { listCommentsByCccIdOrVarId } from '../fn/inventory/list-comments-by-ccc-id-or-var-id';
import { ListCommentsByCccIdOrVarId$Params } from '../fn/inventory/list-comments-by-ccc-id-or-var-id';
import { listCommentsByMonetaryValueId } from '../fn/inventory/list-comments-by-monetary-value-id';
import { ListCommentsByMonetaryValueId$Params } from '../fn/inventory/list-comments-by-monetary-value-id';
import { listCommentsByValueId } from '../fn/inventory/list-comments-by-value-id';
import { ListCommentsByValueId$Params } from '../fn/inventory/list-comments-by-value-id';
import { listInventories } from '../fn/inventory/list-inventories';
import { ListInventories$Params } from '../fn/inventory/list-inventories';
import { listInventoriesVariablesValues } from '../fn/inventory/list-inventories-variables-values';
import { ListInventoriesVariablesValues$Params } from '../fn/inventory/list-inventories-variables-values';
import { listInventoryMonetaryValues } from '../fn/inventory/list-inventory-monetary-values';
import { ListInventoryMonetaryValues$Params } from '../fn/inventory/list-inventory-monetary-values';
import { listInventoryValues } from '../fn/inventory/list-inventory-values';
import { ListInventoryValues$Params } from '../fn/inventory/list-inventory-values';
import { populateMissingBoardValuesForAllBoards } from '../fn/inventory/populate-missing-board-values-for-all-boards';
import { PopulateMissingBoardValuesForAllBoards$Params } from '../fn/inventory/populate-missing-board-values-for-all-boards';
import { updateInventoryMonetaryValue } from '../fn/inventory/update-inventory-monetary-value';
import { UpdateInventoryMonetaryValue$Params } from '../fn/inventory/update-inventory-monetary-value';
import { updateInventoryValue } from '../fn/inventory/update-inventory-value';
import { UpdateInventoryValue$Params } from '../fn/inventory/update-inventory-value';
import { updateValues } from '../fn/inventory/update-values';
import { UpdateValues$Params } from '../fn/inventory/update-values';

@Injectable({ providedIn: 'root' })
export class InventoryService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listInventories()` */
  static readonly ListInventoriesPath = '/v1/boards/{boardId}/inventories';

  /**
   * List Inventories.
   *
   * List Inventories
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInventories()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventories$Response(
    params: ListInventories$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListInventoriesResponse>> {
    return listInventories(this.http, this.rootUrl, params, context);
  }

  /**
   * List Inventories.
   *
   * List Inventories
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInventories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventories(params: ListInventories$Params, context?: HttpContext): Observable<ApiListInventoriesResponse> {
    return this.listInventories$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListInventoriesResponse>): ApiListInventoriesResponse => r.body)
    );
  }

  /** Path part for operation `listInventoriesVariablesValues()` */
  static readonly ListInventoriesVariablesValuesPath = '/v1/boards/{boardId}/inventories/values';

  /**
   * List Inventories values grouped by variables.
   *
   * List Inventories values grouped by variables
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInventoriesVariablesValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoriesVariablesValues$Response(
    params: ListInventoriesVariablesValues$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiInventoriesVariablesValuesResponse>> {
    return listInventoriesVariablesValues(this.http, this.rootUrl, params, context);
  }

  /**
   * List Inventories values grouped by variables.
   *
   * List Inventories values grouped by variables
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInventoriesVariablesValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoriesVariablesValues(
    params: ListInventoriesVariablesValues$Params,
    context?: HttpContext
  ): Observable<ApiInventoriesVariablesValuesResponse> {
    return this.listInventoriesVariablesValues$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<ApiInventoriesVariablesValuesResponse>): ApiInventoriesVariablesValuesResponse => r.body
      )
    );
  }

  /** Path part for operation `updateValues()` */
  static readonly UpdateValuesPath = '/v1/boards/{boardId}/inventories/values';

  /**
   * Update Values and MonetaryValues.
   *
   * Update Values and MonetaryValues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateValues()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateValues$Response(params: UpdateValues$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return updateValues(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Values and MonetaryValues.
   *
   * Update Values and MonetaryValues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateValues$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateValues(params: UpdateValues$Params, context?: HttpContext): Observable<string> {
    return this.updateValues$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `listCommentsByCccIdOrVarId()` */
  static readonly ListCommentsByCccIdOrVarIdPath = '/v1/boards/{boardId}/inventories/values/comments';

  /**
   * Get comments by cccId.
   *
   * Get comments by cccId, excluding costs related variables within ccc
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCommentsByCccIdOrVarId()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommentsByCccIdOrVarId$Response(
    params: ListCommentsByCccIdOrVarId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListCommentsResponse>> {
    return listCommentsByCccIdOrVarId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get comments by cccId.
   *
   * Get comments by cccId, excluding costs related variables within ccc
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCommentsByCccIdOrVarId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommentsByCccIdOrVarId(
    params: ListCommentsByCccIdOrVarId$Params,
    context?: HttpContext
  ): Observable<ApiListCommentsResponse> {
    return this.listCommentsByCccIdOrVarId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListCommentsResponse>): ApiListCommentsResponse => r.body)
    );
  }

  /** Path part for operation `getInventory()` */
  static readonly GetInventoryPath = '/v1/boards/{boardId}/inventories/{id}';

  /**
   * Get Inventory.
   *
   * get Inventory
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInventory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventory$Response(
    params: GetInventory$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiInventoryResponse>> {
    return getInventory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Inventory.
   *
   * get Inventory
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInventory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInventory(params: GetInventory$Params, context?: HttpContext): Observable<ApiInventoryResponse> {
    return this.getInventory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiInventoryResponse>): ApiInventoryResponse => r.body)
    );
  }

  /** Path part for operation `listInventoryMonetaryValues()` */
  static readonly ListInventoryMonetaryValuesPath = '/v1/boards/{boardId}/inventories/{id}/monetary-values';

  /**
   * List Inventory MonetaryValues.
   *
   * List Inventory MonetaryValues
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInventoryMonetaryValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryMonetaryValues$Response(
    params: ListInventoryMonetaryValues$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListMonetaryValuesResponse>> {
    return listInventoryMonetaryValues(this.http, this.rootUrl, params, context);
  }

  /**
   * List Inventory MonetaryValues.
   *
   * List Inventory MonetaryValues
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInventoryMonetaryValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryMonetaryValues(
    params: ListInventoryMonetaryValues$Params,
    context?: HttpContext
  ): Observable<ApiListMonetaryValuesResponse> {
    return this.listInventoryMonetaryValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListMonetaryValuesResponse>): ApiListMonetaryValuesResponse => r.body)
    );
  }

  /** Path part for operation `createInventoryMonetaryValue()` */
  static readonly CreateInventoryMonetaryValuePath = '/v1/boards/{boardId}/inventories/{id}/monetary-values';

  /**
   * Create Inventory MonetaryValue.
   *
   * Create Inventory MonetaryValue
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInventoryMonetaryValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryMonetaryValue$Response(
    params: CreateInventoryMonetaryValue$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiMonetaryValueResponse>> {
    return createInventoryMonetaryValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Inventory MonetaryValue.
   *
   * Create Inventory MonetaryValue
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInventoryMonetaryValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryMonetaryValue(
    params: CreateInventoryMonetaryValue$Params,
    context?: HttpContext
  ): Observable<ApiMonetaryValueResponse> {
    return this.createInventoryMonetaryValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiMonetaryValueResponse>): ApiMonetaryValueResponse => r.body)
    );
  }

  /** Path part for operation `listInventoryValues()` */
  static readonly ListInventoryValuesPath = '/v1/boards/{boardId}/inventories/{id}/values';

  /**
   * List Inventory Values.
   *
   * List Inventory Values
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInventoryValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryValues$Response(
    params: ListInventoryValues$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListValuesResponse>> {
    return listInventoryValues(this.http, this.rootUrl, params, context);
  }

  /**
   * List Inventory Values.
   *
   * List Inventory Values
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listInventoryValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInventoryValues(params: ListInventoryValues$Params, context?: HttpContext): Observable<ApiListValuesResponse> {
    return this.listInventoryValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListValuesResponse>): ApiListValuesResponse => r.body)
    );
  }

  /** Path part for operation `createInventoryValue()` */
  static readonly CreateInventoryValuePath = '/v1/boards/{boardId}/inventories/{id}/values';

  /**
   * Create Inventory Value.
   *
   * Create Inventory Value
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInventoryValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryValue$Response(
    params: CreateInventoryValue$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiValueResponse>> {
    return createInventoryValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Inventory Value.
   *
   * Create Inventory Value
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInventoryValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryValue(params: CreateInventoryValue$Params, context?: HttpContext): Observable<ApiValueResponse> {
    return this.createInventoryValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiValueResponse>): ApiValueResponse => r.body)
    );
  }

  /** Path part for operation `updateInventoryMonetaryValue()` */
  static readonly UpdateInventoryMonetaryValuePath =
    '/v1/boards/{boardId}/inventories/{inventoryId}/monetary-values/{id}';

  /**
   * Update Inventory MonetaryValue.
   *
   * Update Inventory MonetaryValue
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInventoryMonetaryValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryMonetaryValue$Response(
    params: UpdateInventoryMonetaryValue$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateInventoryMonetaryValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Inventory MonetaryValue.
   *
   * Update Inventory MonetaryValue
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInventoryMonetaryValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInventoryMonetaryValue(params: UpdateInventoryMonetaryValue$Params, context?: HttpContext): Observable<string> {
    return this.updateInventoryMonetaryValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `listCommentsByMonetaryValueId()` */
  static readonly ListCommentsByMonetaryValueIdPath =
    '/v1/boards/{boardId}/inventories/{inventoryId}/monetary-values/{monetaryValueId}/comments';

  /**
   * Get comments for a monetary value.
   *
   * Get comments for a monetary value
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCommentsByMonetaryValueId()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommentsByMonetaryValueId$Response(
    params: ListCommentsByMonetaryValueId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListCommentsResponse>> {
    return listCommentsByMonetaryValueId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get comments for a monetary value.
   *
   * Get comments for a monetary value
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCommentsByMonetaryValueId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommentsByMonetaryValueId(
    params: ListCommentsByMonetaryValueId$Params,
    context?: HttpContext
  ): Observable<ApiListCommentsResponse> {
    return this.listCommentsByMonetaryValueId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListCommentsResponse>): ApiListCommentsResponse => r.body)
    );
  }

  /** Path part for operation `createInventoryMonetaryValueComment()` */
  static readonly CreateInventoryMonetaryValueCommentPath =
    '/v1/boards/{boardId}/inventories/{inventoryId}/monetary-values/{monetaryValueId}/comments';

  /**
   * Create Inventory Monetary Value Comment.
   *
   * Create Inventory Monetary Value Comment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInventoryMonetaryValueComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryMonetaryValueComment$Response(
    params: CreateInventoryMonetaryValueComment$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return createInventoryMonetaryValueComment(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Inventory Monetary Value Comment.
   *
   * Create Inventory Monetary Value Comment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInventoryMonetaryValueComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryMonetaryValueComment(
    params: CreateInventoryMonetaryValueComment$Params,
    context?: HttpContext
  ): Observable<string> {
    return this.createInventoryMonetaryValueComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateInventoryValue()` */
  static readonly UpdateInventoryValuePath = '/v1/boards/{boardId}/inventories/{inventoryId}/values/{id}';

  /**
   * Update Inventory Value.
   *
   * Update Inventory Value
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInventoryValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  updateInventoryValue$Response(
    params: UpdateInventoryValue$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateInventoryValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Inventory Value.
   *
   * Update Inventory Value
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInventoryValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  updateInventoryValue(params: UpdateInventoryValue$Params, context?: HttpContext): Observable<string> {
    return this.updateInventoryValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `listCommentsByValueId()` */
  static readonly ListCommentsByValueIdPath =
    '/v1/boards/{boardId}/inventories/{inventoryId}/values/{valueId}/comments';

  /**
   * Get comments for a value.
   *
   * Get comments for a value
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCommentsByValueId()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommentsByValueId$Response(
    params: ListCommentsByValueId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListCommentsResponse>> {
    return listCommentsByValueId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get comments for a value.
   *
   * Get comments for a value
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCommentsByValueId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommentsByValueId(
    params: ListCommentsByValueId$Params,
    context?: HttpContext
  ): Observable<ApiListCommentsResponse> {
    return this.listCommentsByValueId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListCommentsResponse>): ApiListCommentsResponse => r.body)
    );
  }

  /** Path part for operation `createInventoryValueComment()` */
  static readonly CreateInventoryValueCommentPath =
    '/v1/boards/{boardId}/inventories/{inventoryId}/values/{valueId}/comments';

  /**
   * Create Inventory Value Comment.
   *
   * Create Inventory Value Comment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInventoryValueComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryValueComment$Response(
    params: CreateInventoryValueComment$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return createInventoryValueComment(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Inventory Value Comment.
   *
   * Create Inventory Value Comment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInventoryValueComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInventoryValueComment(params: CreateInventoryValueComment$Params, context?: HttpContext): Observable<string> {
    return this.createInventoryValueComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `populateMissingBoardValuesForAllBoards()` */
  static readonly PopulateMissingBoardValuesForAllBoardsPath = '/v1/inventories/populate-all-missing-values';

  /**
   * Populate missing values for all boards.
   *
   * Populate missing values for all boards
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `populateMissingBoardValuesForAllBoards()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  populateMissingBoardValuesForAllBoards$Response(
    params: PopulateMissingBoardValuesForAllBoards$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return populateMissingBoardValuesForAllBoards(this.http, this.rootUrl, params, context);
  }

  /**
   * Populate missing values for all boards.
   *
   * Populate missing values for all boards
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `populateMissingBoardValuesForAllBoards$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  populateMissingBoardValuesForAllBoards(
    params: PopulateMissingBoardValuesForAllBoards$Params,
    context?: HttpContext
  ): Observable<string> {
    return this.populateMissingBoardValuesForAllBoards$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }
}
